import styled from "styled-components";
import { FlexContainer, Title } from "../../styled";
import Scrollbars from "react-custom-scrollbars";
import OutlinedInputStyle from "@material-ui/core/OutlinedInput";
import InputAdornmentStyle from "@material-ui/core/InputAdornment";
import AccordionStyle from "@material-ui/core/Accordion";
import AccordionSummaryStyle from "@material-ui/core/AccordionSummary";
import AccordionDetailsStyle from "@material-ui/core/AccordionDetails";
import { AccordionActions } from "@material-ui/core";
import ListItemStyle from "@material-ui/core/ListItem";

export const Menu = styled(FlexContainer)`
  background-color: ${(props) => props.theme.bg};
  color: ${(props) => props.theme.title};
  flex-flow: column;
  border-right: 0.2px solid #e0e0e0;
  padding: 27px 5px 0 32px;
  position: relative;
  min-width: fit-content;
  justify-content: start;

  h1 {
    font-size: 1.5rem;
    text-align: start;
    margin-bottom: 20px;
    & + div {
      margin-bottom: 12px;
    }
  }

  @media (max-width: 768px) {
    width: 100%;

    &.active {
      display: none;
    }
  }
`;

export const Scrollbar = styled(Scrollbars)`
  min-width: 266px;

  > div:nth-child(3) {
    height: calc(100% - 1rem);

    &:not(.bar) {
      width: 7px !important;
      right: 4px !important;
    }

    > div {
      background-color: ${({ theme }) => theme.scroll}!important;
      opacity: 0.8;
    }
  }
`;

export const Container = styled.ul`
  height: fit-content;
  padding: 0.25rem 27px 2rem 0.25rem;

  h4 {
    font-size: 1rem;
    color: ${(props) => props.theme.title};
    font-weight: normal;
    margin-bottom: 0.8rem;
  }

  li {
    border-radius: 6px;
    padding: 0;
    font-size: 0.8rem;

    &.active {
      font-weight: bold;
    }
    &.hidden {
      display: none;
    }
    &.system {
      color: ${({ theme }) => theme.primary};

      &.active {
        color: ${({ theme }) => theme.primaryText};
        background-color: ${({ theme }) => theme.primary};
      }
    }

    &.business {
      color: ${({ theme }) => theme.secondary};

      &.active {
        color: ${({ theme }) => theme.secondaryText};
        background-color: ${({ theme }) => theme.secondary};
      }
    }

    a {
      color: inherit;
      width: 100%;
      text-decoration: none;
      padding: 0.75rem 0.8rem;

      > span {
        font-weight: bold;
      }
    }

    & + li {
      margin-top: 0.75rem;
    }

    & + h4 {
      margin-top: 1.5rem;
    }
  }
`;

export const OutlinedInput = styled(OutlinedInputStyle)`
  && {
    height: 32px;
    width: calc(100% - 32px);
    border-bottom: 1px solid #b3adbd;
    border-radius: 0px;
    > fieldset {
      border: none;
    }
    svg {
      cursor: pointer;
    }
  }
`;

export const InputAdornment = styled(InputAdornmentStyle)`
  && {
    margin-right: 6px;
    color: #8f8a97;
  }
`;

export const AccordionSummary = styled(AccordionSummaryStyle)`
  && {
    min-height: unset !important;
    padding: 2px 12px 2px 0 !important;

    > div {
      margin: 0 !important;
    }

    h4 {
      color: var(--Gray-06, #8f8a97);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;
export const Accordion = styled(AccordionStyle)`
  && {
    margin: 0 !important;
    padding: 0;
    box-shadow: none !important;
    border: 0 !important;
    background-color: transparent;
    &:before {
      background-color: transparent;
    }
    &:not(.Mui-expanded) {
      ${AccordionSummary} {
        .content {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }
    &:not(:last-child) {
      border-bottom: 1px solid #eceef6 !important;
    }
  }
`;
export const AccordionDetails = styled(AccordionDetailsStyle)`
  && {
    padding: 0px 16px 12px;
    display: flex;
    flex-direction: column;
    &.ticket_file {
      > div {
        min-height: calc(64px + 16px);
      }
    }
    a {
      text-decoration: none;
      color: var(--Gray-08, #48454c);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;

export const StyleAccordionActions = styled(AccordionActions)`
  && {
    padding: 0px 16px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const ListItem = styled(ListItemStyle)`
  && {
    border-left: 1px solid #e1dee5;
    &.active {
      border-left: 1px solid #7d3ce8;
      background: linear-gradient(90deg, white 8px, #f6f7fc 0);
    }
    cursor: pointer;
    span,
    a {
      text-decoration: none;
      color: var(--Gray-08, #48454c);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;
